import InlineImagePlugin from './plugins/InlineImagePlugin';
import inlineImageResizePluginTrigger from './utils/inlineImageResizePluginTrigger';
import { LazyImport, LazyModule } from 'owa-bundling';
import createLazyPlugin from 'owa-editor-lazy-plugin/lib/utils/createLazyPlugin';
var lazyModule = new LazyModule(function () {
    return System.import(/* webpackChunkName: "InlineImages" */ './lazyIndex');
});
export var LazyInlineImageResizePluginClass = createLazyPlugin(lazyModule, function (m) { return m.InlineImageResizePlugin; }, 'InlineImageResize', inlineImageResizePluginTrigger);
export var lazyGetSelectedImage = new LazyImport(lazyModule, function (m) { return m.getSelectedImage; });
export { InlineImagePlugin };
//# sourceMappingURL=index.js.map